import React, { useState } from "react";

//From
//https://tomduffytech.com/how-to-format-phone-number-in-react/
//still has issue with cursor jumping to end when erasing some parts of the number

function formatPhoneNumber(value) {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early

  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

export function PhoneInputComponent({ onChange, ...props }) {
  const [inputValue, setInputValue] = useState("");

  const handleChange = (e) => {
    // this is where we'll call our future formatPhoneNumber function that we haven't written yet.
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    // we'll set the input value using our setInputValue
    setInputValue(formattedPhoneNumber);
    // console.log(formattedPhoneNumber);
    e.target.value = formattedPhoneNumber;
    // console.log(e);
    onChange(e);
  };

  return (
    <input
      type="tel"
      onChange={(e) => handleChange(e)}
      value={inputValue}
      {...props}
    />
  );
}
